import BlessButton from "@/components/layout/button/green-outline-btn";
import { useModularPermissionsStore } from "@/features/mod-perms/stores/modular-permissions.store";
import React from "react";
import { GrRefresh } from "react-icons/gr";
import { IoReload } from "react-icons/io5";
import { UseQueryResult } from "@tanstack/react-query";
import type { ModPerms } from "@/features/mod-perms/api/get-all-mod-perms";

type Props = {
  fetchControls?: UseQueryResult<ModPerms | null, Error>;
};

const RefreshBtn = ({ fetchControls }: Props) => {
  const hasDelegates = useModularPermissionsStore(
    (state) => state.delegatePermissions.length,
  );

  const handleClick = () => {
    fetchControls?.refetch();
  };

  if (!hasDelegates && fetchControls?.isFetched)
    return (
      <BlessButton size={"medium"} onClick={handleClick}>
        <GrRefresh size={17} />
      </BlessButton>
    );
};

export default RefreshBtn;
